// ================================================================
// CompanySidebar — نوار دومِ آبی‌کم‌رنگ: لیست شرکت‌ها + سرچ
// با کلیک روی آیکونِ «سناریوها» باز/بسته می‌شود.
// ================================================================

import { t } from '../../i18n/index.js';
import { icon, escapeHtml, delegate } from '../../utils/dom.js';
import { events, EVENTS } from '../../core/events.js';
import { listOrgs } from '../../core/platform.js';
import { openCompanyScenario } from '../../core/scenarioStore.js';

let containerEl = null;
const s = {
  open: false,
  loaded: false,
  loading: false,
  error: '',
  companies: [],
  query: '',
  selectedId: '',
};

export function renderCompanySidebar(container) {
  containerEl = container;

  delegate(containerEl, '[data-id]', 'click', (e, el) => {
    s.selectedId = el.dataset.id;
    drawList();
    openCompanyScenario(el.dataset.id).catch((err) => {
      console.warn('Could not open company scenario:', err);
    });
  });

  containerEl.addEventListener('input', (e) => {
    if (e.target.matches('.cs-search-input')) {
      s.query = e.target.value;
      drawList(); // فقط لیست رو به‌روز کن تا فوکوسِ سرچ نپره
    }
  });

  events.on(EVENTS.SIDEBAR_COMPANIES_TOGGLE, toggle);
  events.on(EVENTS.LANGUAGE_CHANGED, () => { if (s.open) draw(); });

  draw();
}

function toggle() {
  s.open = !s.open;
  if (s.open && !s.loaded && !s.loading) load();
  else draw();
}

async function load() {
  s.loading = true; s.error = ''; draw();
  try {
    s.companies = (await listOrgs()).organizations || [];
    s.loaded = true;
  } catch (e) {
    s.error = e.message || 'Error';
  } finally {
    s.loading = false;
    draw();
  }
}

function filtered() {
  const q = s.query.trim().toLowerCase();
  if (!q) return s.companies;
  return s.companies.filter(c =>
    (c.name || '').toLowerCase().includes(q) ||
    (c.slug || '').toLowerCase().includes(q)
  );
}

function draw() {
  if (!containerEl) return;
  containerEl.classList.toggle('open', s.open);
  if (!s.open) { containerEl.innerHTML = ''; return; }

  containerEl.innerHTML = `
    <div class="cs-head">
      <span class="cs-title">${escapeHtml(t('companiesSidebar.title'))}</span>
    </div>
    <div class="cs-search">
      ${icon('search', 18)}
      <input class="cs-search-input" type="text" autocomplete="off"
        placeholder="${escapeHtml(t('companiesSidebar.searchPlaceholder'))}"
        value="${escapeHtml(s.query)}" />
    </div>
    <div class="cs-list" id="cs-list">${listHtml()}</div>
  `;
}

function drawList() {
  const listEl = containerEl.querySelector('#cs-list');
  if (listEl) listEl.innerHTML = listHtml();
}

function listHtml() {
  if (s.loading) return `<p class="cs-muted">${escapeHtml(t('companiesSidebar.loading'))}</p>`;
  if (s.error) return `<p class="cs-muted cs-error">${escapeHtml(s.error)}</p>`;
  const items = filtered();
  if (!items.length) return `<p class="cs-muted">${escapeHtml(t('companiesSidebar.empty'))}</p>`;
  return items.map(c => `
    <button class="cs-item ${s.selectedId === c.id ? 'active' : ''}" data-id="${escapeHtml(c.id)}">
      <span class="cs-item-name">${escapeHtml(c.name)}</span>
      <span class="cs-item-slug">${escapeHtml(c.slug || '')}</span>
    </button>
  `).join('');
}
